import { ClientFactories, Store } from 'bernie-plugin-mobx';
import { ClientLogger } from 'bernie-client';

import {
  RewardsPricingInfoStore,
  PageTitleStore,
  SearchResultsStore,
  DialogsStore,
  BannersStore,
  ErrorStore,
  ListingsStore,
  SearchFormStore,
  SearchCriteriaStore,
  SortFilterStore,
  AdvertisingStore,
  OpinionLabStore,
  ClientMetadataStore,
  FlightInformationStore,
  FlightServicingStore,
  FlightServicingConfirmationStore,
  ServicingCriteriaStore,
  ServicingConfirmationCriteriaStore,
  FreeCancellationStore,
  InformationCriteriaStore,
  InformationMetaCriteriaStore,
  InformationResultStore,
  MessagingCardsStore,
  FlexibleSearchResultsStore,
  FlexibleSearchStore,
  PriceSummaryStore,
  FlightsSelectedJourneyReviewStore,
  CheapestListingInfoStore,
  DynamicElementsStore,
  StepIndicatorStore,
  GaiaIdStore,
  DetailsAndFaresStore,
  SearchFormResponseStore,
  JourneyContinuationIdStore,
  MultiItemStore,
  JourneyStartEndDatesStore,
  CreditRedemptionStore,
  FlightsSupportedAncillariesStore,
  ListingsHeaderPlacardsStore,
  FlightsInfoPriceMatchPromiseStore,
  VirtualAgentStore,
  VirtualAgentFlightCheckoutStore,
  PartnerEarnCardStore,
  FlightsSearchMetadataStore,
  AdditionalShoppingStore
} from './';
import { ApiOperations } from 'src/__generated__/api';

const { getLoggerWithIdentifier } = ClientLogger;
export const stores: ClientFactories = {
  rewardsPricingInfoStore: () => {
    return new RewardsPricingInfoStore({}, getLoggerWithIdentifier('store.rewardsPricingInfo'));
  },
  pageTitleStore: () => {
    return new PageTitleStore({}, getLoggerWithIdentifier('store.pageTitle'));
  },
  opinionLabStore: () => {
    return new OpinionLabStore({}, getLoggerWithIdentifier('store.opinionLab'));
  },
  searchResults: options => {
    return new SearchResultsStore(ApiOperations.withClient, {}, getLoggerWithIdentifier('store.searchResults'), {
      'Device-User-Agent-ID': options.bexApiContext.identity.duaid
    });
  },
  dialogsStore: () => {
    return new DialogsStore({}, getLoggerWithIdentifier('store.dialogs'));
  },
  bannersStore: () => {
    return new BannersStore({}, getLoggerWithIdentifier('store.banners'));
  },
  errorStore: () => {
    return new ErrorStore(ErrorStore.DEFAULTS, getLoggerWithIdentifier('store.error'));
  },
  listingsStore: () => {
    return new ListingsStore({}, getLoggerWithIdentifier('store.listings'));
  },
  sortFilterStore: () => {
    return new SortFilterStore({}, getLoggerWithIdentifier('store.sortFilter'));
  },
  searchFormStore: () => {
    return new SearchFormStore({}, getLoggerWithIdentifier('store.searchForm'));
  },
  searchCriteriaStore: () => {
    return new SearchCriteriaStore({}, getLoggerWithIdentifier('store.searchCriteria'));
  },
  advertising: () => {
    return new AdvertisingStore({}, getLoggerWithIdentifier('pwa.flight.advertising'));
  },
  clientMetadataStore: () => {
    return new ClientMetadataStore({}, getLoggerWithIdentifier('store.clientMetadata'));
  },
  flightInformationStore: (): Store => {
    return new FlightInformationStore({}, getLoggerWithIdentifier('store.flightInformationStore'));
  },
  flightServicingStore: options => {
    return new FlightServicingStore(
      ApiOperations.withClient,
      {},
      getLoggerWithIdentifier('store.flightServicingStore'),
      {
        'Device-User-Agent-ID': options.bexApiContext.identity.duaid
      }
    );
  },
  servicingCriteriaStore: () => {
    return new ServicingCriteriaStore({}, getLoggerWithIdentifier('store.servicingCriteriaStore'));
  },
  flightServicingConfirmationStore: options => {
    return new FlightServicingConfirmationStore(
      ApiOperations.withClient,
      {},
      getLoggerWithIdentifier('store.flightServicingConfirmationStore'),
      {
        'Device-User-Agent-ID': options.bexApiContext.identity.duaid
      }
    );
  },
  servicingConfirmationCriteriaStore: () => {
    return new ServicingConfirmationCriteriaStore(
      {},
      getLoggerWithIdentifier('store.servicingConfirmationCriteriaStore')
    );
  },
  informationResult: options => {
    return new InformationResultStore(
      ApiOperations.withClient,
      {},
      getLoggerWithIdentifier('store.informationResult'),
      { 'Device-User-Agent-ID': options.bexApiContext.identity.duaid }
    );
  },
  freeCancellationStore: (): Store => {
    return new FreeCancellationStore({}, getLoggerWithIdentifier('store.freeCancellation'));
  },
  informationCriteriaStore: () => {
    return new InformationCriteriaStore({}, getLoggerWithIdentifier('store.informationCriteria'));
  },
  informationMetaCriteriaStore: () => {
    return new InformationMetaCriteriaStore({}, getLoggerWithIdentifier('store.informationMetaCriteria'));
  },
  journeyContinuationIdStore: () => {
    return new JourneyContinuationIdStore({}, getLoggerWithIdentifier('store.journeyContinuationId'));
  },
  messagingCardsStore: () => {
    return new MessagingCardsStore({}, getLoggerWithIdentifier('store.messagingCardsStore'));
  },
  priceSummaryStore: (): Store => {
    return new PriceSummaryStore({}, getLoggerWithIdentifier('store.priceSummary'));
  },
  flexibleSearchResultsStore: (): Store => {
    return new FlexibleSearchResultsStore({}, getLoggerWithIdentifier('store.flexibleSearchResultsStore'));
  },
  flexibleSearchStore: options => {
    return new FlexibleSearchStore(ApiOperations.withClient, {}, getLoggerWithIdentifier('store.flexibleSearchStore'), {
      'Device-User-Agent-ID': options.bexApiContext.identity.duaid
    });
  },
  flightsSelectedJourneyReviewStore: (): Store => {
    return new FlightsSelectedJourneyReviewStore(
      {},
      getLoggerWithIdentifier('store.flightsSelectedJourneyReviewStore')
    );
  },
  cheapestListingInfoStore: () => {
    return new CheapestListingInfoStore({}, getLoggerWithIdentifier('store.cheapestListingInfoStore'));
  },
  dynamicElementsStore: (): Store => {
    return new DynamicElementsStore({}, getLoggerWithIdentifier('store.dynamicElementsStore'));
  },
  stepIndicatorStore: (): Store => {
    return new StepIndicatorStore({}, getLoggerWithIdentifier('store.stepIndicatorStore'));
  },
  gaiaIdStore: (): Store => {
    return new GaiaIdStore({}, getLoggerWithIdentifier('store.gaiaIdStore'));
  },
  journeyStartEndDatesStore: (): Store => {
    return new JourneyStartEndDatesStore({}, getLoggerWithIdentifier('store.journeyStartEndDatesStore'));
  },
  detailsAndFaresStore: (): Store => {
    return new DetailsAndFaresStore({}, getLoggerWithIdentifier('store.detailsAndFaresStore'));
  },
  searchFormResponseStore: options => {
    return new SearchFormResponseStore(
      ApiOperations.withClient,
      {},
      getLoggerWithIdentifier('store.flexibleSearchStore'),
      {
        'Device-User-Agent-ID': options.bexApiContext.identity.duaid
      }
    );
  },
  multiItemStore: options => {
    return new MultiItemStore(ApiOperations.withClient, {}, getLoggerWithIdentifier('store.multiItemStore'), {
      'Device-User-Agent-ID': options.bexApiContext.identity.duaid
    });
  },
  creditRedemptionStore: () => {
    return new CreditRedemptionStore({}, getLoggerWithIdentifier('store.creditRedemptionStore'));
  },
  virtualAgentStore: () => {
    return new VirtualAgentStore({}, getLoggerWithIdentifier('store.virtualAgentStore'));
  },
  virtualAgentFlightCheckoutStore: () => {
    return new VirtualAgentFlightCheckoutStore(
      ApiOperations.withClient,
      {},
      getLoggerWithIdentifier('store.virtualAgentFlightCheckoutStore')
    );
  },
  flightsSupportedAncillariesStore: (): Store => {
    return new FlightsSupportedAncillariesStore({}, getLoggerWithIdentifier('store.flightsSupportedAncillariesStore'));
  },
  listingsHeaderPlacardsStore: () => {
    return new ListingsHeaderPlacardsStore({}, getLoggerWithIdentifier('store.listingsHeaderPlacardsStore'));
  },
  flightsInfoPriceMatchPromiseStore: (): Store => {
    return new FlightsInfoPriceMatchPromiseStore(
      {},
      getLoggerWithIdentifier('store.flightsInfoPriceMatchPromiseStore')
    );
  },
  partnerEarnCardStore: () => {
    return new PartnerEarnCardStore({}, getLoggerWithIdentifier('store.partnerEarnCardStore'));
  },
  flightsSearchMetadataStore: options => {
    return new FlightsSearchMetadataStore(
      ApiOperations.withClient,
      {},
      getLoggerWithIdentifier('store.flightsSearchMetadataStore'),
      {
        'Device-User-Agent-ID': options.bexApiContext.identity.duaid
      }
    );
  },
  additionalShoppingStore: (): Store => {
    return new AdditionalShoppingStore({}, getLoggerWithIdentifier('store.additionalShoppingStore'));
  }
};
